import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { processList } from '../../data/localData'

function CupProcess() {
    return (
        <div className='pb-3'>
            <Container className='py-5'>
                {/* <h2 className='text-center fw-semibold pb-4 pt-4'></h2> */}
                <h1 className='fw-semibold fs-md-25 fs-sm-20 text-center m-0 py-4 py-lg-5' data-aos="zoom-in">
                    Step-by-Step Cup Manufacturing
                </h1>
                <Row xs={2} sm={2} lg={6} className='gy-4 justify-content-center'>
                    {
                        processList.map((img, index) => {
                            return (
                                <Col key={index} className='align-content-center'>
                                    <div className='p-2 p-sm-3 p-md-4 custom-box'>
                                        <img src={img?.image} className='h-100 object-contain w-100' alt="" />
                                    </div>
                                    <h6 className='text-center fw-semibold d-grid gap-1 gap-sm-2'>
                                        <span className='fs-14 fs-sm-12'>Step - {index + 1}</span>
                                        <span className={`fs-16 fs-sm-14 ${(processList?.length == (index + 1)) ? "color-temp" : ""}`}>{img?.title}</span>
                                    </h6>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        </div>
    )
}

export default CupProcess